<template>
  <div :class="isBlueBack ? 'bg-blue-300' : ''">
    <div>
      <div v-if="isDesktop" class="just-desktop">
        <div
          class="gridClass text-sm flex items-center justify-end font-bold h-[48px] laptop:h-[64px]"
        >
          <div
            class="flex items-center justify-end [&>*]:ms-6 text-s text-blue-400"
          >
            <NuxtLink to="https://cp.navatel.ir/auth/login" class="flex justify-center items-center text-blue-600">
                <IconProfile class="me-1" />
                پنل مدیریتی
            </NuxtLink>
            <NuxtLink to="/downloads">
              دانلود اپلیکیشن
            </NuxtLink>
            <NuxtLink to="https://navatel.ir/blog/">
              وبلاگ
            </NuxtLink>
            <NuxtLink to="/support/">
              پشتیبانی
            </NuxtLink>
            <NuxtLink to="/sales-agent">
              اعطای نمایندگی
            </NuxtLink>

            <a href="tel:02182800000" class="text-blue-700 me-6 !ms-0" dir="ltr">
              021 82800000
            </a>
          </div>
        </div>
      </div>
      <div v-else class="just-mobile">
        <div
          class="w-[95vw] mx-auto text-sm flex items-center justify-between font-bold h-[48px] laptop:h-[64px]"
        >
          <div
            class="flex items-center justify-between text-s text-blue-400 w-full"
          >
            <NuxtLink
              to="/"
              class="flex justify-center items-center py-1 text-xl font-bold text-blue-500"
            >
              <NuxtImg
                sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
                width="1000"
                height="1000"
                class="me-1 w-8"
                format="webp"
                quality="100"
                src="/img/icon.webp"
                alt="navatel logo"
              />
              نواتل
            </NuxtLink>

            <a href="tel:02182800000" class="text-blue-700" dir="ltr">
              021 82800000
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- در حالت وب -->
    <div
      class="w-full h-[64px] just-desktop"
      :class="sticky ? '' : 'hidden'"
    ></div>
    <nav
      v-if="isDesktop"
      class="font-bold just-desktop"
      :class="[
        sticky
          ? 'animate-[fade-in_1s_ease-in-out] fixed top-0 bg-gray-100 w-full z-40 shadow-main'
          : '',
        isBlueBack ? 'bg-blue-300' : 'bg-white',
      ]"
    >
      <div class="gridClass">
        <div class="py-2">
          <div class="flex justify-between items-center">
            <div class="">
              <div class="flex justify-between items-center [&>*]:me-6">
                <div class="flex justify-center items-center me-6">
                  <NuxtLink
                    to="/"
                    class="flex justify-center items-center text-4xl text-blue-500"
                  >
                    <NuxtImg
                      sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
                      width="1000"
                      height="1000"
                      class="me-1"
                      :class="sticky ? 'w-10' : 'w-16'"
                      format="webp"
                      quality="100"
                      src="/img/icon.webp"
                      alt="navatel.ir"
                    />
                    نواتل
                  </NuxtLink>
                </div>

                <span
                  v-for="(item, key) of listMenu"
                  :key="key"
                  class="relative"
                  @click="clicked(key)"
                  @mouseenter="mouseEnter(key)"
                  @mouseleave="mouseLeave(key)"
                >
                  <template v-if="item.list">
                    <div
                      :class="
                        item.isShow
                          ? 'text-blue-500 stroke-blue-500 '
                          : 'stroke-blue-700'
                      "
                      class="flex items-center cursor-pointer"
                    >
                      <span>{{ item.title }}</span>
                      <IconArrowDown
                        :class="item.isShow ? 'rotate-180 ' : ''"
                        class="ms-1"
                        alt=""
                      />
                    </div>
                    <SectionSubMenu :data="item" class="z-40" />
                  </template>
                  <template v-else>
                    <span @click="navigateTo(`${item.url}`)">
                      <span class="hover:text-blue-500 cursor-pointer">{{
                        item.title
                      }}</span>
                    </span>
                  </template>
                </span>
              </div>
            </div>
            <NuxtLink 
              v-show="!hiddenBuyButton" 
              :to="shoppingSrc"
              class="bg-blue-500 text-white rounded px-8 py-1 font-medium text-sm laptop:text-base"
              id="onlineShopping_btn"
            >
              خرید آنلاین
            </NuxtLink>
          </div>
        </div>
      </div>
    </nav>
    <!-- // در حالت موبایل -->
    <div
      v-else
      class="just-mobile w-full px-4"
      :class="[
        isBlueBack ? 'bg-blue-300' : 'bg-white',
        sticky ? 'fixed top-0 bg-gray-100 z-40 shadow-main' : '',
      ]"
    >
      <div class="flex flex-col">
        <nav
          class="flex justify-between items-center"
          :class="{ 'h-[70px]': sticky }"
        >
          <button
            class="text-gray-500 w-10 h-10 relative focus:outline-none bg-white focus:bg-white"
            aria-label="Menu Button"
          >
            <div
              class="block w-5 absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 text-blue-700"
              @click="toggleMenu = !toggleMenu"
            >
              <span
                aria-hidden="true"
                class="block absolute h-0.5 w-5 bg-current transform transition duration-500 ease-in-out"
                :class="{
                  'rotate-45': toggleMenu,
                  ' -translate-y-1.5': !toggleMenu,
                }"
              ></span>
              <span
                aria-hidden="true"
                class="block absolute h-0.5 w-5 bg-current transform transition duration-500 ease-in-out"
                :class="{ 'opacity-0': toggleMenu }"
              ></span>
              <span
                aria-hidden="true"
                class="block absolute h-0.5 w-5 bg-current transform transition duration-500 ease-in-out"
                :class="{
                  '-rotate-45': toggleMenu,
                  ' translate-y-1.5': !toggleMenu,
                }"
              ></span>
            </div>

            <transition
              enter-active-class="transform transition duration-500 ease-custom"
              enter-class="-translate-y-1/2 scale-y-0 opacity-0"
              enter-to-class="translate-y-0 scale-y-100 opacity-100"
              leave-active-class="transform transition duration-300 ease-custom"
              leave-class="translate-y-0 scale-y-100 opacity-100"
              leave-to-class="-translate-y-1/2 scale-y-0 opacity-0"
            >
              <div
                v-show="toggleMenu"
                class="absolute -right-4 w-[100vw] mt-4 bg-white rounded-b-lg shadow-lg overflow-hidden font-bold text-right text-blue-700 z-50 pr-8"
              >
                <ul>
                  <li
                    v-for="(item, key) of listMenu"
                    :key="key"
                    @click="clicked(key)"
                  >
                    <template v-if="item.list">
                      <div
                        class="flex items-center my-3"
                        :class="
                          item.isShow
                            ? 'stroke-blue-500 text-blue-500'
                            : 'stroke-blue-700'
                        "
                      >
                        {{ item.title }}
                        <IconArrowDown
                          class="ms-1"
                          :class="item.isShow ? 'rotate-180' : ''"
                        />
                      </div>
                    </template>
                    <template v-else>
                      <NuxtLink @click="closeMenu" :to="item.url" class=" ">
                        {{ item.title }}
                      </NuxtLink>
                    </template>
                    <div v-show="item.isShow" class="my-2 ms-4 text-sm">
                      <div v-for="i in item.list" :key="i.id" class="my-2">
                        <NuxtLink
                          :to="i.url"
                          class="flex items-center w-fit"
                          @click="toggleMenu = false"
                        >
                          <div class="w-4 ml-4">
                            <BaseIcon :name="i.icon" color="text-blue-700" />
                          </div>
                          {{ i.title }}
                        </NuxtLink>
                      </div>
                    </div>
                  </li>
                </ul>
                <div class="grid grid-cols-3 text-sm pb-5">
                  <NuxtLink
                    to="https://cp.navatel.ir/auth/login"
                    @click="toggleMenu = false"
                    class="items-center flex mx-auto py-1 text-blue-500"
                  >
                    <IconProfile class="me-1" />
                    پنل مدیریتی
                  </NuxtLink>
                  <NuxtLink
                    to="https://navatel.ir/blog/"
                    @click="toggleMenu = false"
                  >
                    <div class="py-1">وبلاگ</div>
                  </NuxtLink>
                </div>
                <div class="grid grid-cols-3 text-sm pb-8">
                  <NuxtLink to="/downloads" @click="toggleMenu = false">
                    <div class="py-1">دانلود اپلیکیشن</div>
                  </NuxtLink>
                  <NuxtLink to="/support/" @click="toggleMenu = false">
                    <div class="py-1">پشتیبانی</div>
                  </NuxtLink>

                  <NuxtLink to="/sales-agent" @click="toggleMenu = false">
                    <div class="py-1">اعطای نمایندگی</div>
                  </NuxtLink>
                </div>
              </div>
            </transition>
          </button>
          <NuxtLink 
            v-show="!hiddenBuyButton" 
            :to="shoppingSrc"
            class="bg-blue-500 text-white rounded px-8 py-1 font-medium text-sm laptop:text-base"
            id="onlineShopping_btn"
          >
            خرید آنلاین
          </NuxtLink>
        </nav>
      </div>
    </div>
  </div>
</template>
<script setup>
const props = defineProps({
  isBlueBack: Boolean,
  shoppingSrc: String,
  hiddenBuyButton: Boolean,
});

const { isDesktop } = useScreen();

const sticky = ref(false);
const toggleMenu = ref(false);

const clicked = (name) => {
  listMenu.value[name].isShow = !listMenu.value[name].isShow;
};
const closeMenu = () => {
  toggleMenu.value = false;
};
const mouseEnter = (name) => {
  listMenu.value[name].isShow = true;
};
const mouseLeave = (name) => {
  listMenu.value[name].isShow = false;
};
const setSticky = () => {
  sticky.value = true;
};
const setNotSticky = () => {
  sticky.value = false;
};
onMounted(() => {
  window.addEventListener("scroll", () => {
    if (window.scrollY > 180) {
      setSticky();
    } else {
      setNotSticky();
    }
  });
});

const listMenu = ref({
  menu1: {
    id: "1",
    title: "محصولات",
    isShow: false,
    img: "/img/menu.webp",
    list: [
      {
        id: "1",
        title: "مرکز تلفن ابری",
        icon: "84",
        click: "",
        url: "/products/cloud-pbx/",
      },
      {
        id: "2",
        title: "مرکز تماس ابری",
        icon: "75",
        click: "",
        url: "/products/cloud-callcenter/",
      },
      {
        id: "3",
        title: "تلفن اینترنتی",
        icon: "83",
        click: "",
        url: "/products/internet-phone/",
      },
      {
        id: "7",
        title: "مدیریت ارتباط با مشتری",
        icon: "72",
        click: "",
        url: "/products/crm/",
      },
      {
        id: "9",
        title: "پنل پیامکی",
        icon: "15",
        click: "",
        url: "/products/sms/",
      },
      {
        id: "5",
        title: "فکس‌ ابری",
        icon: "117",
        click: "",
        url: "/products/fax/",
      },
      {
        id: "4",
        title: "چت آنلاین",
        icon: "82",
        click: "",
        url: "/products/webchat/",
      },
      {
        id: "6",
        title: "اپلیکیشن اختصاصی",
        icon: "16",
        click: "",
        url: "/products/dedicated-application/",
      },
      {
        id: "8",
        title: "شماره‌های ابری مخابرات استان تهران",
        // icon: "mokhaberat",
        click: "",
        url: "/rond/",
        isDesktop: false,
      },
    ],
  },
  menu2: {
    id: "2",
    title: "امکانات",
    isShow: false,

    img: "",
    list: [
      {
        id: "1",
        title: "پنل مدیریتی",
        icon: "89",
        click: "",
        url: "/products/management-dashboard/",
      },
      {
        id: "2",
        title: "دفتر کار مجازی",
        icon: "74",
        click: "",
        url: "/products/virtual-office/",
      },
      {
        id: "3",
        title: "تلفن گویا",
        icon: "02",
        click: "",
        url: "/products/smart-ivr/",
      },
      {
        id: "4",
        title: "اتصال به CRM",
        icon: "96",
        click: "",
        url: "/connecting-with-crm/",
      },
      // {
      //   id: "5",
      //   title: "مرکز تماس",
      //   icon: "75",
      //   click: "",
      //   url: "/products/cloud-callcenter/",
      // },
    ],
  },
  menu3: { id: "3", title: "تعرفه ها", url: "/prices/" },
  menu7: {
    id: "4",
    title: "متاما",
    url: "/metama",
  },
  menu4: {
    id: "4",
    title: "منابع",
    isShow: false,

    img: "",

    list: [
      {
        id: "1",
        title: "آموزش",
        icon: "76",
        url: "/",
        click: "",
      },

      {
        id: "4",
        title: "کاتالوگ",
        icon: "78",
        click: "",
        url: "https://navatel.ir/Digital-Catalogue/",
      },
    ],
  },
  menu5: {
    id: "5",
    title: "ارتباط با ما",
    isShow: false,

    img: "",
    list: [
      {
        id: "1",
        title: "درباره ما",
        icon: "21",
        click: "",
        url: "/about-us/",
      },
      {
        id: "2",
        title: "تماس با ما",
        icon: "105",
        click: "",
        url: "/contact-us/",
      },
      {
        id: "4",
        title: "مدیر عامل و معاونین",
        icon: "manager",
        click: "",
        url: "/managers/",
      },
      {
        id: "3",
        title: "فرصت های شغلی",
        icon: "100",
        click: "",
        url: "/",
      },
    ],
  },
  menu6: {
    id: "6",
    title: "نمایشگاه مجازی",
    isShow: false,

    img: "",
    list: [
      {
        id: "1",
        title: "تلکام 24",
        icon: "113",
        click: "",
        url: "https://navatel.ir/virtual-exhibition/telecom24/",
      },
    ],
  },
});
</script>
